import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityFormComponent } from './entity-form/entity-form.component';
import { EntityListComponent } from './entity-list/entity-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { ExternalEntityRoutingModule } from './external-entity-routing.module';
import { ViewLinkedCompaniesComponent } from './view-linked-companies/view-linked-companies.component';
import { EntityBranchFormComponent } from './entity-branch-form/entity-branch-form.component';
import { CreditTermsComponent } from './credit-terms/credit-terms.component';
import { KycDetailsComponent } from './kyc-details/kyc-details.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { EntityBranchListComponent } from './entity-branch-list/entity-branch-list.component';
import { ViewLogComponent } from './view-log/view-log.component';
import { BranchGstDetailsComponent } from './branch-gst-details/branch-gst-details.component';
import { BranchContactComponent } from './branch-contact/branch-contact.component';
import { EntityDisplayComponent } from './entity-display/entity-display.component';
import { SEZComponent } from './sez/sez.component';
import { GroupDetailFormComponent } from './group-detail-form/group-detail-form.component';



@NgModule({
  declarations: [
    EntityFormComponent,
    EntityListComponent,
    ViewLinkedCompaniesComponent,
    EntityBranchFormComponent,
    CreditTermsComponent,
    KycDetailsComponent,
    EntityBranchListComponent,
    ViewLogComponent,
    BranchGstDetailsComponent,
    BranchContactComponent,
    EntityDisplayComponent,
    SEZComponent,
    GroupDetailFormComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AngularMaterialModule,
    SharedModule,
    ExternalEntityRoutingModule,
    ScrollingModule
  ],
  providers: []
})
export class ExternalEntityModule { }
